import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid } from '@mui/x-data-grid';
export default function StudyRecordsTable(props) {
    const adjustedColumns = props.columns.map(function (col) {
        if (col.field === 'irr' || col.field === 'eur_delta') {
            return {
                ...col,
                valueFormatter: function (params) {
                    if (!params) {
                        return '';
                    }
                    return `${params}%`;
                }
            };
        }
        if (col.field === 'p50_frac_npv' || col.field === 'refrac_cost') {
            return {
                ...col,
                valueFormatter: function (params) {
                    if (!params) {
                        return '';
                    }
                    return `$${params}`;
                }
            };
        }
        return col;
    });
    return (_jsx("div", { style: { overflowX: 'auto', width: 'fit-content', backgroundColor: 'white', maxHeight: '1000px' }, children: _jsx(DataGrid, { rows: props.rows, columns: adjustedColumns, onRowClick: props.onRowClick, disableRowSelectionOnClick: true, hideFooter: true, getRowClassName: (params) => params.row.status === 'success' ? 'clickable-row' : '' }) }));
}
